import React, { Component } from 'react';

import ParkinglocationSelect from './ParkinglocationSelect';

import { Form, Input, Button, Modal, Select, InputNumber } from 'antd';
const FormItem = Form.Item;

class ParkingConnlocationsForm extends Component {

    state = {
        modalVisible: false,
        confirmDirty: false,
        coreParkingLocationId: null,
    }

    form = null;

    componentWillReceiveProps(nextProps) {
        this.setState({
            modalVisible: nextProps.modalVisible
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                !values.port && delete values.port;
                this.props.onSuccess(this.props.form, values);
            }
        });
    }

    handleConfirmBlur = e => {
        const { value } = e.target;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    };

    compareToFirstPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && value !== form.getFieldValue('password')) {
            callback('Hesla si musí odpovídat!');
        } else {
            callback();
        }
    };

    validateToNextPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && this.state.confirmDirty) {
            form.validateFields(['confirmPassword'], { force: true });
        }
        callback();
    };

    renderForm() {
        const { getFieldDecorator, getFieldValue } = this.props.form;
        const driverType = getFieldValue('driverType');
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };

        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };

        return (
            <Form onSubmit={this.handleSubmit} ref={ref => { this.form = ref }}>
                <FormItem
                    {...formItemLayout}
                    label="Lokalita" >
                    {getFieldDecorator('coreParkingLocationId', {
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                    })(
                        <ParkinglocationSelect />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Driver" >
                    {getFieldDecorator('driverType', {
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                    })(
                        <Select placeholder='Zvolte driver'>
                            <Select.Option value="Cross-PS4">Cross-PS4</Select.Option>
                            <Select.Option value="Green-Rest-5.4">Green-Rest-5.4</Select.Option>
                            <Select.Option value="Green-Rest-5.6">Green-Rest-5.6</Select.Option>
                            <Select.Option value="Green-WebInterface-5.3.0">Green-WebInterface-5.3.0</Select.Option>
                            <Select.Option value="Invipo-Parking-V2">Invipo-Parking-V2</Select.Option>
                            <Select.Option value="ASParking-V1">ASParking-V1</Select.Option>
                            <Select.Option value="SKIdata">SKIdata</Select.Option>
                            <Select.Option value="Parkinto-V1">Parkinto-V1</Select.Option>
                        </Select>
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Typ" >
                    {getFieldDecorator('requestType', {
                        rules: [{
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                    })(
                        <Select placeholder='Typ'>
                            <Select.Option value="PULL">PULL</Select.Option>
                            <Select.Option value="PUSH">PUSH</Select.Option>
                        </Select>
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Jméno" >
                    {getFieldDecorator('name', {
                        rules: [{
                            type: 'string', message: 'Položka musí být string!',
                        }, {
                            required: true, message: 'Vyplňte prosím tuto položku!',
                        }],
                    })(
                        <Input />
                    )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="Popis">
                    {getFieldDecorator('description', {
                    })(
                        <Input.TextArea autosize={{ minRows: 2, maxRows: 4 }} />
                    )}
                </FormItem>
                {(driverType != 'SKIdata') && (
                    <FormItem
                        {...formItemLayout}
                        label="Protokol" >
                        {getFieldDecorator('protocol', {
                            rules: [{
                                required: true, message: 'Vyplňte prosím tuto položku!',
                            }],
                        })(
                            <Select placeholder='Zvolte protokol'>
                                <Select.Option value="http">http</Select.Option>
                                <Select.Option value="https">https</Select.Option>
                            </Select>
                        )}
                    </FormItem>
                )}
                {(driverType != 'SKIdata') && (
                    <FormItem
                        {...formItemLayout}
                        label="Adresa Url" >
                        {getFieldDecorator('ipAddress', {
                            rules: [{
                                type: 'string', message: 'Položka musí být string!',
                            }, {
                                required: true, message: 'Vyplňte prosím tuto položku!',
                            }],
                        })(
                            <Input />
                        )}
                    </FormItem>
                )}
                {(driverType == 'Cross-PS4' || driverType == 'Green-Rest-5.4' || driverType == 'Green-Rest-5.6' || driverType == 'Green-WebInterface-5.3.0' || driverType == 'ASParking-V1') && (
                    <FormItem
                        {...formItemLayout}
                        label="Port" >
                        {getFieldDecorator('port', {
                            rules: [{
                                type: 'number', message: 'Položka musí být číslo!',
                            }, {
                                required: true, message: 'Vyplňte prosím tuto položku!',
                            }
                            ],
                        })(
                            <InputNumber min={0} max={65535} disabled={driverType === 'Invipo-Parking-V2'} />
                        )}
                    </FormItem>
                )}
                {(driverType == 'Cross-PS4' || driverType == 'Green-Rest-5.4' || driverType == 'Green-Rest-5.6' || driverType == 'Green-WebInterface-5.3.0' || driverType == 'ASParking-V1' || driverType == 'SKIdata') && (
                    <FormItem
                        {...formItemLayout}
                        label="ParkId" >
                        {getFieldDecorator('parkId', {
                            rules: [{
                                type: 'number', message: 'Položka musí být číslo!',
                            }, {
                                required: true, message: 'Vyplňte prosím tuto položku!',
                            }
                            ],
                        })(
                            <InputNumber min={0} max={65535} disabled={driverType === 'Invipo-Parking-V2'} />
                        )}
                    </FormItem>
                )}
                {(driverType == 'Invipo-Parking-V2' || driverType == 'SKIdata') && (
                    <FormItem
                        {...formItemLayout}
                        label="Area" >
                        {getFieldDecorator('area', {
                            rules: [{
                                type: 'string', message: 'Položka musí být string!',
                            }, {
                                required: true, message: 'Vyplňte prosím tuto položku!',
                            }
                            ],
                        })(
                            <Input />
                        )}
                    </FormItem>
                )}
                {driverType == 'SKIdata' && (
                    <FormItem
                        {...formItemLayout}
                        label="FacilityId" >
                        {getFieldDecorator('facilityId', {
                            rules: [{
                                type: 'number', message: 'Položka musí být number!',
                            }, {
                                required: true, message: 'Vyplňte prosím tuto položku!',
                            }
                            ],
                        })(
                            <InputNumber min={0} max={773001300} />
                        )}
                    </FormItem>
                )}
                {(driverType === 'Green-Rest-5.6' || driverType == 'Invipo-Parking-V2') && (
                    <FormItem
                        {...formItemLayout}
                        label="Token" >
                        {getFieldDecorator('token', {
                            rules: [{
                                type: 'string', message: 'Položka musí být string!',
                            }, {
                                required: true, message: 'Vyplňte prosím tuto položku!',
                            }],
                        })(
                            <Input />
                        )}
                    </FormItem>
                )}
                {(driverType == 'Cross-PS4' || driverType == 'Green-Rest-5.4' || driverType == 'SKIdata' || driverType == 'Parkinto-V1') && (
                    <FormItem
                        {...formItemLayout}
                        label="Login" >
                        {getFieldDecorator('login', {
                            rules: [{
                                type: 'string', message: 'Položka musí být string!',
                            }, {
                                required: true, message: 'Vyplňte prosím tuto položku!',
                            }],
                        })(
                            <Input disabled={driverType === 'Green-WebInterface-5.3.0' || driverType === 'Invipo-Parking-V2'} />
                        )}
                    </FormItem>
                )}
                {(driverType == 'Cross-PS4' || driverType == 'Green-Rest-5.4' || driverType == 'ASParking-V1' || driverType == 'SKIdata' || driverType == 'Parkinto-V1') && (
                    <FormItem
                        {...formItemLayout}
                        label="Heslo">
                        {getFieldDecorator('password', {
                            rules: [{
                                type: 'string', message: 'Položka musí být string!',
                            },
                            {
                                required: true, message: 'Vyplňte prosím tuto položku!',
                            },
                            {
                                validator: this.validateToNextPassword,
                            }],
                        })(
                            <Input.Password disabled={driverType === 'Green-WebInterface-5.3.0' || driverType === 'Invipo-Parking-V2'} />
                        )}
                    </FormItem>
                )}
                {(driverType == 'Cross-PS4' || driverType == 'Green-Rest-5.4' || driverType == 'SKIdata' || driverType =='Parkinto-V1') && (
                    <FormItem
                        {...formItemLayout}
                        label="Heslo pro kontrolu">
                        {getFieldDecorator('confirmPassword', {
                            rules: [{
                                type: 'string', message: 'Položka musí být string!',
                            }, {
                                required: true, message: 'Vyplňte prosím tuto položku!',
                            },
                            {
                                validator: this.compareToFirstPassword,
                            }],
                        })(
                            <Input.Password onBlur={this.handleConfirmBlur} disabled={driverType === 'Green-WebInterface-5.3.0' || driverType === 'Invipo-Parking-V2'} />
                        )}
                    </FormItem>
                )}
                <FormItem {...tailFormItemLayout}>
                    <Button type="primary" htmlType="submit">Vložit</Button>
                </FormItem>
            </Form>
        );
    }

    render() {
        if (this.props.type && this.props.type === 'modal') {
            return (
                <Modal
                    width={650}
                    title="Vytvoření nové lokality"
                    visible={this.state.modalVisible}
                    onCancel={() => {
                        this.props.onModalCancel(this.props.form);
                        this.setState({ modalVisible: false });
                    }}
                    footer={<p></p>}>
                    {this.renderForm()}
                </Modal>
            )
        } else {
            return this.renderForm();
        }
    }
}

const WrappedParkingConnlocationsForm = Form.create()(ParkingConnlocationsForm);

export default WrappedParkingConnlocationsForm;


// WEBPACK FOOTER //
// ./src/components/ParkingConnlocationsForm.js